import { Props as SelectProps } from 'react-select';
import { PeliasFeature } from '@symplicity/geocoding';
import { PeliasFormData } from '../location-form.models';

const setValueOptions = {
    shouldDirty: true,
    shouldValidate: true,
};

const getSelectStyles = (hasError: boolean) =>
    ({
        styles: { control: props => ({ ...props, height: '40px' }) },
        classNames: { control: () => (hasError ? 'border-danger' : 'border-input') },
    } satisfies Pick<SelectProps<any, false, never>, 'styles' | 'classNames'>);

const allPeliasFields: (keyof PeliasFormData)[] = ['region', 'city', 'postcode', 'street'];

const featureToLabel = (feature: PeliasFeature) =>
    feature.properties.label.split(', ').slice(0, -1).join(', ');

const locationFieldAdapter = (pelias: PeliasFeature | string | null): string | undefined => {
    if (!pelias) {
        return undefined;
    }

    if (typeof pelias === 'string') {
        return pelias;
    }

    return featureToLabel(pelias);
};

export const locationConstants = {
    setValueOptions,
    allPeliasFields,
    featureToLabel,
    locationFieldAdapter,
    getSelectStyles,
};
